module.exports = __webpack_public_path__ + "static/media/Lars Jensen.97807971.png";